import { render, staticRenderFns } from "./WorkshopCard.vue?vue&type=template&id=51f24f7d&scoped=true&"
import script from "./WorkshopCard.vue?vue&type=script&lang=js&"
export * from "./WorkshopCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopCard.vue?vue&type=style&index=0&id=51f24f7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f24f7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VImg,VProgressCircular,VRow})
